import { getProfile, saveProfile } from '~/services/profile'
import { getDashes, saveDash } from '~/services/dashSettings'
import { getOwnerItems } from '~/services/algolia'
import { isAddress } from '~/utils/validation'
import { toChecksumAddress } from '~/utils/helpers'
import { getSellsByMaker } from '~/services/rarible'

export const state = () => ({
  profile: null,
  collection: null,
  dashes: null,
  sellOrders: null,
})

export const getters = {
  profile: (state) => state.profile,
  collection: (state) => state.collection,
  dashes: (state) => state.dashes,
  sellOrders: (state) => state.sellOrders,
}

export const mutations = {
  setProfile(state, profile) {
    state.profile = profile
  },
  setCollection(state, collection) {
    state.collection = collection
  },
  setDashes(state, newDashes) {
    if (!newDashes) return (state.dashes = null)

    state.dashes = Array(4)
      .fill({ muted: true })
      .map((dash, index) => ({
        ...dash,
        ...newDashes.find(({ dash }) => dash === index + 1),
      }))
  },
  setMuted(state, { dashId, muted }) {
    state.dashes.find(({ dash }) => dash === dashId).muted = muted
  },
  setSellOrders(state, sellOrders) {
    state.sellOrders = sellOrders
  },
}

export const actions = {
  async getProfile({ commit, dispatch, rootState }) {
    commit('setProfile', null)
    commit('setDashes', null)
    commit('setSellOrders', null)

    if (isAddress(rootState.walletAddress)) {
      const profile = await getProfile(rootState.walletAddress)
      commit('setProfile', profile)

      await Promise.all([dispatch('loadDashes'), dispatch('loadSellOrders')])
    }
  },
  clearProfile({ commit }) {
    commit('setProfile', null)
    commit('setCollection', null)
    commit('setDashes', null)
    commit('setSellOrders', null)
  },
  async loadCollection({ commit, rootState }) {
    const items = []
    let nextPage = 0

    while (nextPage != null) {
      const nextPageData = await getOwnerItems(rootState.walletAddress, nextPage)
      nextPage = nextPageData.nextPage
      items.push(...nextPageData.items)
    }

    commit('setCollection', items)
  },
  async loadDashes({ commit, rootState }) {
    const dashes = await getDashes(rootState.walletAddress)
    commit('setDashes', dashes)
  },
  async saveProfile({ commit, state, dispatch }, data) {
    const { address } = data
    if (!isAddress(address)) {
      throw new Error(`Error saving profile, invalid address ${address}`)
    }
    const existingProfile = state.profile || {}
    // Updates properties
    const savedProfile = await saveProfile({
      ...existingProfile,
      ...data,
      address: toChecksumAddress(address),
    })
    console.log({ savedProfile })
    commit('setProfile', savedProfile)

    dispatch('otherUserProfile/getProfile', address, { root: true })
  },
  async saveDash({ commit }, data) {
    const { address } = data
    console.log(data)
    if (!isAddress(address)) {
      throw new Error(`Error saving Experience settings, invalid address! ${address}`)
    }
    const savedDashes = await saveDash({
      ...data,
      address: toChecksumAddress(address),
    })
    console.log({ savedDashes })
    commit('setDashes', savedDashes)
  },
  async loadSellOrders({ commit, rootState }) {
    const orders = await getSellsByMaker(rootState.walletAddress)
    commit('setSellOrders', orders)
  },
}
